import React from 'react';
import { css, Global } from '@emotion/react';

const RolePlaySubmissionModalStyles = () => (
  <Global
    styles={css`
      .modal-page.role-play-submission {
        .modal-content-wrapper,
        .modal-page-content,
        .modal-page-content .modal-page-content-inner {
          height: 100%;
          min-height: 0;
        }
        .modal-content-wrapper {
          overflow: hidden;
        }
        nv-react-component.react-app {
          display: flex;
          flex-direction: column;
          height: 100%;
          min-height: 0;
        }
      }
    `}
  />
);

export default RolePlaySubmissionModalStyles;
